import { EventInput } from "@fullcalendar/core/index.js";
import { Task } from "../types/task";
import { AvailableTurnos, VisitForCalendar } from "../types/visitas";


export const parseTasksToEvents = (tasks: Task[]): EventInput[] => {
    const events: EventInput[] = [];
    tasks.map((task) => {
        events.push({
            id: task.id.toString(),
            title: task.titulo,
            start: task.fechaInicial,
            end: task.fechaFinal
        });
    })
    return events;
}

export const parseConfirmedDealsToEvents = (deals: VisitForCalendar[]): EventInput[] => {
    const events: EventInput[] = [];
    deals.map((visit) => {
        events.push({
            id: visit.id.toString(),
            title: visit.nombre,
            start: visit.fechaVisita,
            color: getColorEventByHorario(visit.turno),
        });
    })
    return events;
}

export const getColorEventByHorario = (turno: string) => {
    switch (turno as AvailableTurnos) {
        case "Matutino": return "#16a34a"
        case "Vespertino": return "#3788d8";
        case "Nocturno": return "#800080";
        default: return "#3788d8";
    }
}

export const getColorVisitDate = (turno: string) => {
    switch (turno as AvailableTurnos) {
        case "Matutino": return "#d1fae5"
        case "Vespertino": return "#dbeafe";
        case "Nocturno": return "#f3e8ff";
        default: return "#dbeafe";
    }
}

export const parseTaskDate = (fecha: string, hora?: string): string => {
    return `${fecha.replaceAll("-", "/")}${hora ? " - " + hora : ""}`;
}

export const parseDateToInput = (fecha: string, hora?: string): string => {
    return `${fecha.replaceAll("/", "-")}${hora ? "T" + hora : ""}`;
}

export const reverseDate = (fecha: string): string => {
    const dateParts = fecha.split("/").reverse();
    return `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`
}

export const parseDateToISOFormat = (fecha: Date): string => {
    return fecha.toISOString().substring(0, 10);
}

export const formatDate = (date = new Date(), agregarDias: number = 0): string => {
    const year = date.toLocaleString('default', { year: 'numeric'});
    const month = date.toLocaleString('default', { month: '2-digit'});
    const day = date.toLocaleString('default', { day: '2-digit'});

    return [year, month, day].join('-');
}

export const subtractDays = (date: Date, days: number): Date => {
    const newDay = date.getDate() - days;
    return new Date(date.setDate(newDay))
}
